import { createContext, useContext, type ReactNode } from "react";
import { apiClient, type ApiClient } from "./client";

const ApiClientContext = createContext<ApiClient>(apiClient);

export function ApiClientProvider({
  client,
  children,
}: {
  client: ApiClient;
  children: ReactNode;
}) {
  return (
    <ApiClientContext.Provider value={client}>
      {children}
    </ApiClientContext.Provider>
  );
}

export function useApiClient(): ApiClient {
  return useContext(ApiClientContext);
}
